import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { getCartDiscountAmount } from "@app/modules/checkout/store/v2/selectors/get-discount-amount";
import {
  getCart,
  getCartStatus,
  getCurrency,
  getWhitelabel
} from "@app/modules/checkout/store/v2/selectors/state-accessors";
import {
  addDiscountCode,
  removeDiscountCode
} from "@app/modules/checkout/store/v2/thunks/discount";
import { hasRootCodeDiscount } from "@app/modules/checkout/utils/cart-v2";
import type { CheckoutReduxStateV2 } from "@app/types/checkout-v2-types";
import type { TaxBreakdown } from "@app/types/napi-types";

import type { CartCharges } from "./fee-list";
import type { Dispatch } from "@reduxjs/toolkit";
import type { ConnectedProps } from "react-redux";

import { FeeList } from "./fee-list";

const mapStateToProps = (state: CheckoutReduxStateV2) => {
  const currency = getCurrency(state);
  const cart = getCart(state);
  const whitelabel = getWhitelabel(state);
  const cart_is_loading = getCartStatus(state);

  const tax_breakdown: TaxBreakdown | undefined =
    state.cart.charges.tax_breakdown;

  const { total, subtotal, taxes, fees } = cart.charges;

  let code_discount: null | number = null;
  if (hasRootCodeDiscount(state.cart)) {
    code_discount = getCartDiscountAmount(state) || 0;
  }

  const cart_charges: CartCharges = {
    total,
    subtotal,
    taxes,
    fees: fees.total,
    busbud_fee: fees.busbud || 0,
    code_discount
  };

  return {
    cart_charges,
    currency,
    whitelabel,
    tax_breakdown,
    cart_is_loading
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    actions: bindActionCreators(
      {
        addDiscountCode,
        removeDiscountCode
      },
      dispatch
    )
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ConnectorProps = ConnectedProps<typeof connector>;

const connected = connector(FeeList);

export { connected as FeeList };
